import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig, msalInstance } from './app/app.config';
import { App } from './app/app';

msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then(() => {
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
});
